export default function Spinner() {
	return (
		<div className="mx-auto flex size-5 animate-spin items-center justify-center rounded-full border-2 border-neutral-500 border-t-white"></div>
	);
}
